<template>
  <div class="flex items-center">
    <a :href="modelValue" target="_blank">
      <icon-base height="24" width="24" :icon="IconLink" />
    </a>
  </div>
</template>

<script>
import IconLink from "@/components/icons/IconLink.vue";

export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },
  setup() {
    return { IconLink };
  },
};
</script>
